import network3g from './3g.svg';
import network4g from './4g.svg';
import network5g from './5g.svg';
import add from './add.svg';
import arrowLeft from './arrow-left.svg';
import bev from './bev.svg';
import block from './block.svg';
import bluetooth from './bluetooth.svg';
import car from './car.svg';
import caretDown from './caret-down.svg';
import chart from './chart.svg';
import check from './check.svg';
import circleFill from './circle-fill.svg';
import close from './close.svg';
import cloud from './cloud.svg';
import electricalServices from './electrical-services.svg';
import emissions from './emissions.svg';
import ethernet from './ethernet.svg';
import gasStation from './gas-station.svg';
import info from './info.svg';
import leaf from './leaf.svg';
import lightning from './lightning.svg';
import networkLte from './lte.svg';
import monetization from './monetization.svg';
import pencil from './pencil.svg';
import phev from './phev.svg';
import print from './print.svg';
import refresh from './refresh.svg';
import remove from './remove.svg';
import searchCatalog from './searchCatalog.svg';
import share from './share.svg';
import speedIndicator from './speed-indicator.svg';
import trash from './trash.svg';
import wifi from './wifi.svg';
import zappy from './zappy.svg';
var icons = {
    info: info,
    'caret-down': caretDown,
    pencil: pencil,
    check: check,
    'electrical-services': electricalServices,
    trash: trash,
    'speed-indicator': speedIndicator,
    car: car,
    chart: chart,
    emissions: emissions,
    'gas-station': gasStation,
    monetization: monetization,
    BEV: bev,
    PHEV: phev,
    'arrow-left': arrowLeft,
    lightning: lightning,
    close: close,
    '3g': network3g,
    '4g': network4g,
    '5g': network5g,
    lte: networkLte,
    wifi: wifi,
    bluetooth: bluetooth,
    ethernet: ethernet,
    zappy: zappy,
    block: block,
    leaf: leaf,
    cloud: cloud,
    'circle-fill': circleFill,
    refresh: refresh,
    'search-catalog': searchCatalog,
    remove: remove,
    add: add,
    print: print,
    share: share,
};
export default icons;
